export default {
  data: () => ({
    perPage: 10,
    totalRows: 1,
    currentPage: 1,
    pageOptions: [3, 5, 10, 25, 50, 100, 200],
    sortBy: '',
    sortDesc: true,
    filterBy: '',
    filter: '',
    timeout: null,
    debounceMilliseconds: 250
  }),
  model: {
    prop: 'items',
    event: 'update:items'
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    defaultFilterBy: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.getPagination()
      .finally(() => {
        this.filterBy = this.defaultFilterBy
      })
  },
  watch: {
    currentPage () { this.getPagination() },
    perPage () { this.getPagination() },
    sortBy () { this.getPagination() },
    sortDesc () { this.getPagination() },
    filter () { this.getPagination() },
    filterBy () { if (this.filter !== '') this.getPagination() }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    filterValue () {
      return this.filterBy !== ''
        ? this.filterBy
        : this.sortOptions.length > 0
          ? this.sortOptions[0].value
          : ''
    }
  },
  methods: {
    async getPagination () {
      this.filterBy = this.filterValue

      const url = `${this.url}/${this.perPage}?page=${this.currentPage}&sortBy=${this.sortBy}&sortDesc=${this.sortDesc}&filterBy=${this.filterBy}&filter=${this.filter}`

      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        this.loading = true
        await this.$http.get(url)
          .then(res => {
            this.$emit('raw', res.data)
            this.$emit('update:items', res.data.data)
            this.$emit('total', res.data.total)
            this.totalRows = res.data.total
          })
          .finally(() => {
            this.loading = false
          })
      }, this.debounceMilliseconds)
    },
    sortingChanged (item) {
      this.sortBy = item.sortBy
      this.sortDesc = item.sortDesc
      this.getPagination()
    }
  }
}
